


import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';


import { TableModule } from 'primeng-lts/table';
import { RadioButtonModule } from 'primeng-lts/radiobutton';
import { CheckboxModule } from 'primeng-lts/checkbox';


import { FormsModule } from '@angular/forms';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { DialogModule } from 'primeng-lts/dialog';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { DossierHeaderModule } from '../../dossiers/components/dossierHeader.module';

import { TenderClassificationComponent } from './component/tenderClassification.component';
import { InputNumberModule } from 'primeng-lts/inputnumber';

@NgModule({
  declarations: [TenderClassificationComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormPlycaModule,
    FormsModule,
    TableModule,
    RadioButtonModule,
    CheckboxModule,
    DialogModule,
    SubHeaderModule,
    DossierHeaderModule,
    ScrollPanelModule,
    InputNumberModule
  ]
})
export class TenderClassificationModule { }